import { Link } from "react-router-dom";
import translate from "./../services/translation.json";
import "./../assets/scss/home.scss";
import OurClients from "../components/ourClients/ourClients";
import ProductLifecycle from "../components/productLifecycle/productLifecycle";
import home_banner from "./../assets/images/home_banner.png";
import { servicesData as servicesTabsData } from "../components/servicesTabs/servicesData";

import creativityIcon from "./../assets/images/creativity_icon.svg";
import teamworkIcon from "./../assets/images/teamwork_icon.svg";
import innovationIcon from "./../assets/images/innovation_icon.svg";
import qualityIcon from "./../assets/images/quality_icon.svg";
import simplicityIcon from "./../assets/images/simplicity_icon.svg";
import integrityIcon from "./../assets/images/integrity_icon.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { useState, useEffect, useMemo } from "react";

const Home = ({ lang }) => {
  const [isMobile, setIsMobile] = useState(false);
  const homepage = translate[lang].homepage;
  const teasers = homepage.service_teasers || {};

  useEffect(() => {
    // Keep in sync with SCSS `@mixin mobile` (max-width: 960px)
    const check = () => setIsMobile(window.innerWidth <= 960);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const servicesData = useMemo(() => {
    return servicesTabsData[lang].sections.flatMap(
      (section) => section.services
    );
  }, [lang]);

  const coreValuesData = [
    {
      image: creativityIcon,
      title: homepage.core_values.creativity_title,
      desc: homepage.core_values.creativity_desc,
    },
    {
      image: teamworkIcon,
      title: homepage.core_values.teamwork_title,
      desc: homepage.core_values.teamwork_desc,
    },
    {
      image: innovationIcon,
      title: homepage.core_values.innovation_title,
      desc: homepage.core_values.innovation_desc,
    },
    {
      image: qualityIcon,
      title: homepage.core_values.quality_title,
      desc: homepage.core_values.quality_desc,
    },
    {
      image: simplicityIcon,
      title: homepage.core_values.simplicity_title,
      desc: homepage.core_values.simplicity_desc,
    },
    {
      image: integrityIcon,
      title: homepage.core_values.integrity_title,
      desc: homepage.core_values.integrity_desc,
    },
  ];

  const renderServiceCard = (service) => {
    const IconComponent = service.icon;
    const teaser =
      teasers[service.id] ||
      service.groups[0]?.text?.slice(0, 140) ||
      "";

    return (
      <div className="service">
        <IconComponent className="service-icon" size={60} />
        <h2 className="service-title">{service.title}</h2>
        <p className="service-desc">{teaser}</p>
        <Link
          to={`/services?service=${service.id}`}
          className="service-link"
        >
          {homepage.services_learn_more}
        </Link>
      </div>
    );
  };

  const renderDesktopSwiper = () => (
    <Swiper
      modules={[Pagination, Autoplay]}
      spaceBetween={30}
      slidesPerView={3}
      centeredSlides={false}
      loop={true}
      pagination={{
        clickable: true,
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active",
      }}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      breakpoints={{
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      }}
    >
      {servicesData.map((service) => (
        <SwiperSlide key={service.id}>{renderServiceCard(service)}</SwiperSlide>
      ))}
    </Swiper>
  );

  const renderMobileSwiper = () => (
    <Swiper
      modules={[Pagination, Autoplay]}
      spaceBetween={0}
      slidesPerView={1}
      centeredSlides={true}
      loop={true}
      watchOverflow={true}
      observer={true}
      observeParents={true}
      pagination={{
        clickable: true,
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active",
      }}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
    >
      {servicesData.map((service) => (
        <SwiperSlide key={service.id}>{renderServiceCard(service)}</SwiperSlide>
      ))}
    </Swiper>
  );

  return (
    <div className="homepage page-container">
      <div
        className="homepage-banner"
        style={{ backgroundImage: `url(${home_banner})` }}
      >
        <h1 className="homepage-title no-underline-title">
          {homepage.banner_title_engineering}{" "}
          <span className="blue">{homepage.banner_title_digital}</span>
        </h1>
        <p className="homepage-subtitle">{homepage.banner_subtitle}</p>
        <div className="banner-buttons">
          <a href="#contact" className="banner-btn">
            {homepage.banner_contact_button}
          </a>
        </div>
      </div>
      <div className="homepage_content" id="page_content">
        <div className="homepage-services">
          <h1>{homepage.our_services}</h1>
          <div className="services-container">
            {isMobile ? renderMobileSwiper() : renderDesktopSwiper()}
          </div>
        </div>
        <OurClients lang={lang} />
        <ProductLifecycle lang={lang} />
        <div className="our-values">
          <div className="mw-1200">
            <h1>{homepage.our_values}</h1>
            <div className="values-container">
              {coreValuesData.map((value, i) => (
                <div className="value" key={`value-${i}`}>
                  <img src={value.image} alt={`${value.title}-img`} />
                  <h2 className="value-title">{value.title}</h2>
                  <p className="value-desc">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
